import React from "react";
import "./LoadingBlog.css";
export default function LoadingBlog() {
  return <span class="loader"></span>;
}
